import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
import { Reveal } from './ui/Reveal';
export function GuaranteeSection() {
  return <section aria-labelledby="garantia" className="bg-carbon" data-id="element-82" data-mp="4vrzzwt0kbqc">
      <div className="mx-auto max-w-page px-3 py-6 sm:px-6 sm:py-7" data-id="element-83" data-mp="9ttgc9z21wy4">
        <Reveal className="mx-auto flex max-w-2xl flex-col items-center gap-1.5 rounded-2xl border-2 border-gold bg-carbon-soft p-3.5 text-center sm:p-5" data-id="element-84" data-mp="9wpe9yawklmk">
          <p className="text-[0.66rem] font-extrabold uppercase tracking-[0.22em] text-muted sm:text-xs" data-id="element-85" data-mp="jrr7b58au7uf">
            Tu inversión está protegida
          </p>
          <span className="flex h-11 w-11 items-center justify-center rounded-full bg-gold" data-id="element-86" data-mp="sl49kxs96lt6">
            <ShieldCheckIcon size={24} className="text-carbon" data-id="element-87" data-mp="xjnvwzardzm2" />
          </span>
          <h2 id="garantia" className="font-display text-xl uppercase leading-none tracking-wide text-coral sm:text-3xl" data-id="element-88" data-mp="xlrv53xpqag0">
            🛡️ Garantía total de 7 días
          </h2>
          <p className="text-[0.8rem] leading-snug text-beige sm:text-sm" data-id="element-89" data-mp="25rx6qgm90hvt">
            Tienes 7 días para explorar los 6 módulos y los 5 bonos. Si
            consideras que el sistema no es adecuado para ti, puedes solicitar
            un reembolso dentro del período establecido según los términos de
            devolución.
          </p>
        </Reveal>
      </div>
    </section>;
}